export default __webpack_public_path__ + "static/media/fad-logo-cubase.3a359940.svg";